import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const TextBox = styled(Form.Control)`
  height: 36px !important;
`;

export default TextBox;
